// Mock data for urban walks directory
export const mockWalks = [
  {
    id: 1,
    title: "Silver Lake Reservoir & Murals",
    slug: "silver-lake-reservoir-murals",
    description: "Discover the artistic soul of Silver Lake on this scenic loop around the iconic reservoir, featuring stunning street murals and architectural gems.",
    practicalSummary: "A 2.2-mile loop combining natural beauty with LA's vibrant street art scene. Perfect for morning coffee walks or sunset strolls.",
    startingPoint: "Silver Lake Reservoir Dog Park",
    endingPoint: "Silver Lake Reservoir Dog Park",
    startingCoords: { lat: 34.0928, lng: -118.2747 },
    endingCoords: { lat: 34.0928, lng: -118.2747 },
    routeCoordinates: [
      { lat: 34.0928, lng: -118.2747 },
      { lat: 34.0930, lng: -118.2745 },
      { lat: 34.0932, lng: -118.2743 },
      { lat: 34.0935, lng: -118.2740 },
      { lat: 34.0938, lng: -118.2738 },
      { lat: 34.0940, lng: -118.2735 },
      { lat: 34.0943, lng: -118.2732 },
      { lat: 34.0945, lng: -118.2729 },
      { lat: 34.0948, lng: -118.2726 },
      { lat: 34.0950, lng: -118.2723 },
      { lat: 34.0928, lng: -118.2747 }
    ],
    transitAccess: "Metro Bus 2, 4, 302 to Silver Lake Blvd",
    duration: "45-60 minutes",
    distance: "2.2 miles",
    difficulty: "Easy",
    category: "Secret LA",
    theme: "Architecture",
    funCategories: {
      themeSong: "LA Love (La La) - Fergie",
      vibeIn3Words: "Artsy, Chill, Bohemian",
      instagramMoment: "The colorful mural wall on Sunset Junction with reservoir backdrop",
      perfectSnack: "Iced coffee from local roaster and a croissant from the French Market",
      walkingChallenge: "Count how many different art styles you spot in the murals",
      movieThatMatches: "Her (2013)"
    },
    photos: [
      "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop"
    ],
    highlights: [
      {
        title: "Neutra VDL House",
        description: "Iconic modernist architecture by Richard Neutra",
        coords: { lat: 34.0925, lng: -118.2735 }
      },
      {
        title: "Reservoir Steps",
        description: "Historic WPA-era staircases with city views",
        coords: { lat: 34.0935, lng: -118.2755 }
      }
    ],
    bestTimes: "Early morning (7-9 AM) or golden hour (5-7 PM). Avoid midday heat in summer.",
    accessibility: {
      strollerFriendly: true,
      wheelchairAccessible: false,
      parkingAvailable: true,
      restrooms: true,
      shadeCoverage: "Moderate"
    },
    rating: 4.8,
    favoriteCount: 234,
    createdAt: "2024-12-01"
  },
  {
    id: 2,
    title: "Best Scenic Urban Walk - Griffith Park Sunrise Loop (Los Angeles, CA)",
    slug: "griffith-observatory-hollywood-sign",
    description: "Experience LA's most iconic landmarks on this challenging hike that rewards you with panoramic city views and that perfect Hollywood Sign photo.",
    practicalSummary: "Explore one of the best sunrise walks in Los Angeles. This 4-mile loop in Griffith Park offers epic views, a peaceful route, and a perfect start to your day.",
    startingPoint: "Griffith Observatory",
    endingPoint: "Griffith Observatory",
    startingCoords: { lat: 34.1184, lng: -118.3004 },
    endingCoords: { lat: 34.1184, lng: -118.3004 },
    routeCoordinates: [
      { lat: 34.1184, lng: -118.3004 },
      { lat: 34.1190, lng: -118.3010 },
      { lat: 34.1195, lng: -118.3015 },
      { lat: 34.1200, lng: -118.3020 },
      { lat: 34.1205, lng: -118.3025 },
      { lat: 34.1210, lng: -118.3030 },
      { lat: 34.1215, lng: -118.3035 },
      { lat: 34.1220, lng: -118.3040 },
      { lat: 34.1225, lng: -118.3045 },
      { lat: 34.1230, lng: -118.3050 },
      { lat: 34.1184, lng: -118.3004 }
    ],
    transitAccess: "DASH Observatory bus (weekends) or Uber/Lyft",
    duration: "2-3 hours",
    distance: "4.0 miles",
    difficulty: "Moderate",
    category: "Long-Distance Treks",
    theme: "Nature & Parks",
    trailheadAddress: "2800 E Observatory Rd, Los Angeles, CA 90027",
    bestTimeOfYear: "October through April for coolest temperatures",
    bestTimeOfDay: "Sunrise (6:00-8:00 AM) for best lighting and fewer crowds",
    dogFriendly: true,
    kidStrollerFriendly: false,
    funCategories: {
      themeSong: "Here Comes the Sun - The Beatles",
      vibeIn3Words: "Epic, Peaceful, Inspiring",
      instagramMoment: "Golden hour Hollywood Sign view from Mount Hollywood summit",
      perfectSnack: "Trail mix and coffee in a thermos for that sunrise energy",
      walkingChallenge: "Spot 5 different LA neighborhoods from the observatory viewpoint",
      movieThatMatches: "La La Land (2016)"
    },
    photos: [
      "https://images.unsplash.com/photo-1580655653885-65763b2597d0?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1576863272535-a8e9c3e39d10?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&h=600&fit=crop"
    ],
    highlights: [
      {
        title: "Griffith Observatory",
        description: "Art Deco masterpiece with planetarium and exhibits",
        coords: { lat: 34.1184, lng: -118.3004 }
      },
      {
        title: "Hollywood Sign Viewpoint",
        description: "Closest legal viewing point of the iconic sign",
        coords: { lat: 34.1341, lng: -118.3215 }
      }
    ],
    bestTimes: "Early morning (6-8 AM) or late afternoon (4-6 PM). Avoid peak summer heat.",
    accessibility: {
      strollerFriendly: false,
      wheelchairAccessible: false,
      parkingAvailable: true,
      restrooms: true,
      shadeCoverage: "Limited"
    },
    rating: 4.9,
    favoriteCount: 456,
    createdAt: "2024-11-28",
    seoTags: ["#griffithpark", "#losangeleswalk", "#sunrisewalks", "#urbanloop", "#bestwalksLA"]
  },
  {
    id: 3,
    title: "Venice Beach Boardwalk to Canals",
    slug: "venice-beach-boardwalk-canals",
    description: "From the eclectic energy of Venice Beach to the serene, European-inspired canals, this walk captures the full Venice experience.",
    practicalSummary: "A 2.8-mile linear walk showcasing Venice's diverse personalities. End at the romantic canals for a perfect contrast to the bustling boardwalk.",
    startingPoint: "Venice Beach Boardwalk (Windward Ave)",
    endingPoint: "Venice Canals (Dell Ave)",
    startingCoords: { lat: 34.0195, lng: -118.4912 },
    endingCoords: { lat: 34.0122, lng: -118.4695 },
    transitAccess: "Metro Expo Line to Downtown Santa Monica, then bus",
    duration: "1.5-2 hours",
    distance: "2.8 miles",
    difficulty: "Easy",
    category: "Family-Friendly",
    theme: "Historic LA",
    funCategories: {
      themeSong: "California Dreamin' - The Mamas & The Papas",
      vibeIn3Words: "Eclectic, Vibrant, Charming",
      instagramMoment: "The rainbow bridge over the Venice Canals with gondola boats",
      perfectSnack: "Fish tacos from a boardwalk vendor and fresh coconut water",
      walkingChallenge: "Find 3 street performers and guess their next song",
      movieThatMatches: "Lords of Dogtown (2005)"
    },
    photos: [
      "https://images.unsplash.com/photo-1580655653885-65763b2597d0?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=800&h=600&fit=crop"
    ],
    highlights: [
      {
        title: "Venice Beach Boardwalk",
        description: "Iconic beachside promenade with street performers",
        coords: { lat: 34.0195, lng: -118.4912 }
      },
      {
        title: "Abbot Kinney Boulevard",
        description: "Trendy shopping and dining district",
        coords: { lat: 34.0089, lng: -118.4742 }
      },
      {
        title: "Venice Canals",
        description: "Historic waterways inspired by Venice, Italy",
        coords: { lat: 34.0122, lng: -118.4695 }
      }
    ],
    bestTimes: "Late afternoon (3-5 PM) for best light and activity. Weekends are more crowded but more vibrant.",
    accessibility: {
      strollerFriendly: true,
      wheelchairAccessible: true,
      parkingAvailable: true,
      restrooms: true,
      shadeCoverage: "Good"
    },
    rating: 4.6,
    favoriteCount: 189,
    createdAt: "2024-11-25"
  },
  {
    id: 4,
    title: "Echo Park Lake & Hidden Staircases",
    slug: "echo-park-lake-hidden-staircases",
    description: "Explore the bohemian heart of Echo Park with its lotus-filled lake, then discover the neighborhood's secret staircases and murals.",
    practicalSummary: "A 2.5-mile exploration combining lakeside serenity with urban adventure. Perfect for discovering LA's hidden architectural gems.",
    startingPoint: "Echo Park Lake Boathouse",
    endingPoint: "Echo Park Lake Boathouse",
    startingCoords: { lat: 34.0735, lng: -118.2605 },
    endingCoords: { lat: 34.0735, lng: -118.2605 },
    transitAccess: "Metro Red Line to Downtown, then bus 2 or 302",
    duration: "1.5-2 hours",
    distance: "2.5 miles",
    difficulty: "Easy",
    category: "Secret LA",
    theme: "Architecture",
    funCategories: {
      themeSong: "Echo - Jason Walker",
      vibeIn3Words: "Peaceful, Hidden, Romantic",
      instagramMoment: "Lotus flowers blooming on Echo Park Lake with downtown skyline",
      perfectSnack: "Elote from a park vendor and horchata to stay cool",
      walkingChallenge: "Climb all 5 hidden staircases and count the steps on each one",
      movieThatMatches: "500 Days of Summer (2009)"
    },
    photos: [
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1580655653885-65763b2597d0?w=800&h=600&fit=crop"
    ],
    highlights: [
      {
        title: "Echo Park Lake",
        description: "Historic lake with lotus flowers and paddle boats",
        coords: { lat: 34.0735, lng: -118.2605 }
      },
      {
        title: "Baxter Street Steps",
        description: "Steep historic staircase with neighborhood views",
        coords: { lat: 34.0756, lng: -118.2587 }
      }
    ],
    bestTimes: "Morning (8-10 AM) when the lake is peaceful, or golden hour (5-7 PM) for best photos.",
    accessibility: {
      strollerFriendly: true,
      wheelchairAccessible: true,
      parkingAvailable: true,
      restrooms: true,
      shadeCoverage: "Good"
    },
    rating: 4.7,
    favoriteCount: 167,
    createdAt: "2024-11-22"
  },
  {
    id: 5,
    title: "Sunset Strip Architecture Tour",
    slug: "sunset-strip-architecture-tour",
    description: "Walk the legendary Sunset Strip and discover its architectural evolution from Art Deco clubs to modern glass towers.",
    practicalSummary: "A 3-mile linear walk along one of LA's most famous streets. Rich in music history and architectural diversity.",
    startingPoint: "Chateau Marmont",
    endingPoint: "Whisky a Go Go",
    startingCoords: { lat: 34.0969, lng: -118.3850 },
    endingCoords: { lat: 34.0908, lng: -118.3884 },
    transitAccess: "Metro Bus 2 or 302 along Sunset Boulevard",
    duration: "2-2.5 hours",
    distance: "3 miles",
    difficulty: "Easy",
    category: "Architecture",
    theme: "Historic LA",
    funCategories: {
      themeSong: "Hotel California - Eagles",
      vibeIn3Words: "Iconic, Glamorous, Electric",
      instagramMoment: "Sunset reflection on the glass facade of Sunset Plaza with neon signs",
      perfectSnack: "Classic martini and truffle fries at a rooftop bar overlooking the Strip",
      walkingChallenge: "Spot 10 different architectural decades from Art Deco to modern",
      movieThatMatches: "Once Upon a Time in Hollywood (2019)"
    },
    photos: [
      "https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1576863272535-a8e9c3e39d10?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&h=600&fit=crop"
    ],
    highlights: [
      {
        title: "Chateau Marmont",
        description: "Iconic hotel in French Chateau style",
        coords: { lat: 34.0969, lng: -118.3850 }
      },
      {
        title: "Sunset Plaza",
        description: "Mid-century modern shopping and dining",
        coords: { lat: 34.0928, lng: -118.3867 }
      },
      {
        title: "Whisky a Go Go",
        description: "Historic music venue with distinctive facade",
        coords: { lat: 34.0908, lng: -118.3884 }
      }
    ],
    bestTimes: "Late afternoon (4-6 PM) for golden hour lighting. Evening (7-9 PM) to see the Strip come alive.",
    accessibility: {
      strollerFriendly: true,
      wheelchairAccessible: true,
      parkingAvailable: true,
      restrooms: true,
      shadeCoverage: "Good"
    },
    rating: 4.5,
    favoriteCount: 203,
    createdAt: "2024-11-20"
  }
];

export const categories = [
  "Nature & Parks",
  "Hidden Gems",
  "Architecture",
  "Food-Focused Walks",
  "Scenic Walks",
  "Historic Walks",
  "Family-Friendly",
  "Sunset Walks"
];

export const difficulties = ["Easy", "Moderate", "Hard"];

export const regions = [
  "Silver Lake",
  "Griffith Park", 
  "Venice",
  "Echo Park",
  "Hollywood",
  "West Hollywood",
  "Downtown LA",
  "Santa Monica"
];

// Enhanced user favorites system with custom lists
export const getUserLists = () => {
  // One-time cleanup: remove seeded demo walk IDs (numbers) from lists
  const migrated = localStorage.getItem('wanderloopLists_v2');
  if (!migrated) {
    localStorage.removeItem('wanderloopLists');
    localStorage.setItem('wanderloopLists_v2', '1');
  }

  const lists = localStorage.getItem('wanderloopLists');
  if (lists) {
    return JSON.parse(lists);
  }

  // Start with an empty favorites list — no demo data
  const defaultLists = {
    'favorites': {
      id: 'favorites',
      name: 'My Favorites',
      description: 'All your saved walks',
      walks: [],
      createdAt: new Date().toISOString(),
      isDefault: true
    }
  };

  localStorage.setItem('wanderloopLists', JSON.stringify(defaultLists));
  return defaultLists;
};

export const createList = (name, description = '') => {
  const lists = getUserLists();
  const listId = name.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-');
  
  if (lists[listId]) {
    throw new Error('A list with this name already exists');
  }
  
  lists[listId] = {
    id: listId,
    name: name,
    description: description,
    walks: [],
    createdAt: new Date().toISOString(),
    isDefault: false
  };
  
  localStorage.setItem('wanderloopLists', JSON.stringify(lists));
  return lists[listId];
};

export const deleteList = (listId) => {
  const lists = getUserLists();
  if (lists[listId] && !lists[listId].isDefault) {
    delete lists[listId];
    localStorage.setItem('wanderloopLists', JSON.stringify(lists));
    return true;
  }
  return false;
};

export const addWalkToList = (walkId, listId = 'favorites') => {
  const lists = getUserLists();
  if (lists[listId] && !lists[listId].walks.includes(walkId)) {
    lists[listId].walks.push(walkId);
    localStorage.setItem('wanderloopLists', JSON.stringify(lists));
    
    // Trigger event for FloatingActions to update
    window.dispatchEvent(new Event('listToggled'));
  }
  return lists;
};

export const removeWalkFromList = (walkId, listId = 'favorites') => {
  const lists = getUserLists();
  if (lists[listId]) {
    const index = lists[listId].walks.indexOf(walkId);
    if (index > -1) {
      lists[listId].walks.splice(index, 1);
      localStorage.setItem('wanderloopLists', JSON.stringify(lists));
      
      // Trigger event for FloatingActions to update
      window.dispatchEvent(new Event('listToggled'));
    }
  }
  return lists;
};

export const getWalkLists = (walkId) => {
  const lists = getUserLists();
  const walkLists = [];
  
  Object.values(lists).forEach(list => {
    if (list.walks.includes(walkId)) {
      walkLists.push(list);
    }
  });
  
  return walkLists;
};

export const isWalkInList = (walkId, listId = 'favorites') => {
  const lists = getUserLists();
  return lists[listId] ? lists[listId].walks.includes(walkId) : false;
};

// Legacy functions for backwards compatibility
export const getUserFavorites = () => {
  const lists = getUserLists();
  return lists.favorites ? lists.favorites.walks : [];
};

export const toggleFavorite = (walkId) => {
  const lists = getUserLists();
  const isInFavorites = lists.favorites.walks.includes(walkId);
  
  if (isInFavorites) {
    removeWalkFromList(walkId, 'favorites');
  } else {
    addWalkToList(walkId, 'favorites');
  }
  
  return lists.favorites.walks;
};

export const isFavorite = (walkId) => {
  return isWalkInList(walkId, 'favorites');
};